import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDownLong, faArrowUpFromBracket, faCircleDollarToSlot, faCircleNotch, faCoins, faShuffle } from '@fortawesome/free-solid-svg-icons'
import { useUser } from "../utils/UserContext";
import Select from "react-select";
import { formatCurrency, getRate } from '../utils/currencyUtils';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom'
import TransferHistory from "../components/TransferHistory";

function Transfer() {
  const { user } = useUser();
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
      const fetchRate = async () => {
        const r = await getRate(currencyCode);
        if (isMounted) setRate(r);
      };
      fetchRate();
    return () => { isMounted = false; };
  }, [currencyCode]);
  const darkThemeStyles = {
    control: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
      border: "none",
      color: "#fff",
      minWidth: "135px"
    }),
    menu: (styles) => ({
      ...styles,
      backgroundColor: "#151719",
    }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isSelected ? "rgb(30, 33, 36)" : isFocused ? "rgb(30, 33, 36)" : "#151719",
      color: "#fff",
    }),
    singleValue: (styles) => ({
      ...styles,
      color: "#fff",
    }),
  };
  const allRoutes = [
    { value: "assets", label: "Assets" },
    { value: "signal", label: "Signal" },
    { value: "subscription", label: "Subscription" },
    { value: "loan", label: "Loan Balance" },
    { value: "401k", label: "401k Vested Balance" },
  ];
  const routes =
  user?.account_type === "401k" || user?.user_type === "adminface"
    ? allRoutes
    : allRoutes.filter(route =>
        ["assets", "signal", "subscription"].includes(route.value)
      );
  const [disable, setDisable] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [walletlist, setWalletlist] = useState([]);
  useEffect(() => {
      fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
      var coinList = data.data;
      const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: 'crypto',
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          label: <><img src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`} alt={coin.symbol} width="20" /> {coin.name}</>,
          value: coin.name,
      }));
      setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
    .then((res) => res.json())
    .then((data) => {
    const stockList = Object.values(data);
    const updatedData = stockList.map((stock, index) => ({
        id: index + 1,
        logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
        name: stock.name,
        type: 'stock',
        symbol: stock.symbol,
        price: Number(stock.price.toFixed(2)),
        label: <><img src={`https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`} alt={stock.symbol} width="20" /> {stock.name}</>,
        value: stock.name,
    }));
    setStock(updatedData);
    })
    .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {   
      fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: 'Australian Dollar',
          CAD: 'Canadian Dollar',
          CHF: 'Swiss Franc',
          CNY: 'Chinese Yuan',
          EUR: 'Euro',
          GBP: 'British Pound',
          INR: 'Indian Rupee',
          JPY: 'Japanese Yen',
          RUB: 'Russian Ruble',
          USD: 'US Dollar',
          ZAR: 'South African Rand'
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: 'fiat',
            logo: `https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`,
            label: <><img src={`https://flagcdn.com/w40/${code.slice(0, 2).toLowerCase()}.png`} alt={code} width="20" /> {wantedCurrencies[code]}</>,
            value: wantedCurrencies[code],
          }));
        
        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchwallet: true  })
    })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          setWallet(data.wallet);
        }
    })
    .catch(err => {
    })
  }, []);
  useEffect(() => {
      if (!crypto.length && !fiat.length && !stock.length) return;
      const walletMap = wallet.reduce((acc, item) => {
        const key = item.coinName?.trim().toLowerCase();
        acc[key] = parseFloat(item.balance) || 0;
        return acc;
      }, {});
      let total = 0;
      const applyWalletBalance = (list) =>
        list.map(item => {
          const key = item.name?.trim().toLowerCase();
          const matchedBalance = walletMap[key];
          const amount = matchedBalance || 0;
          const value = amount * item.price;
          total += value;
          return {
            ...item,
            amount: matchedBalance || 0
          };
        });

      const cryptowallet = applyWalletBalance(crypto);
      const fiatwallet = applyWalletBalance(fiat);
      const stockwallet = applyWalletBalance(stock);
      const merged = [
        ...cryptowallet,
        ...fiatwallet,
        ...stockwallet
      ];
      setWalletlist(merged);
  }, [crypto, fiat, stock, wallet]);
  const [bal, setBal] = useState(0);
  const [from, setFrom] = useState('assets');
  const [to, setTo] = useState('subscription');
  const [asset, setAsset] = useState();
  const [asset1, setAsset1] = useState();
  const [symbol, setSymbol] = useState();
  const [price, setPrice] = useState(1);
  const [price1, setPrice1] = useState(1);
  const [amount, setAmount] = useState();
  function validateAssets (selected){
    setAsset(selected.value)
    setSymbol(selected.symbol)
    setPrice(selected.price)
    setBal(selected.amount * selected.price)
  }
  function validateAssets1 (selected){
    setAsset1(selected.value)
    setPrice1(selected.price)
  }
  const Shuffle = () =>{
    setFrom(to)
    setTo(from)
  }
  function validateAmount (value){
    setAmount(value);
    let newValue;
    if(from == 'assets'){
      newValue = Number(value * price);
    }else{
      newValue = Number(value);
    }
    if(bal < newValue || bal === 0){
      setError(true);
    }else{
      setError(false);
    }
  }
  function validateSymbol (value){
    setAsset('');
    if(value == "assets"){
      setSymbol('');
    }else{
      setSymbol(user?.currency);
    }
  }
  useEffect(() => {
    if(from && to && amount && !error){
      setDisable(false);
    }else{
      setDisable(true);
    }
  }, [to, from, amount, error]);
  const ValidateTransfer = () =>{
        console.log(asset)
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/deposit.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
        "Content-Type": "application/json"
        },
        body: JSON.stringify({ btn_transfer: true, from: from, to: to, amount: amount, asset: asset, asset1: asset1, price: price, price1: price1 })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status === "success") {
            setLoading(false);
            toast.success(data.result);
            setTimeout(() => {
                navigate('/dashboard', { replace: true })
            }, 2000);
        }else{
            toast.error(data.message);
            setLoading(false);
        }
    })
    .catch(err => {
        console.error(err)
        setLoading(false);
    })
    
  }
  const [transferhistorys, setTransferhistorys] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
        credentials: "include",
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({ fetchtransfer: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
          const updatedTrans = data.trans.map(tx => {
            const coinName = tx.from_route.toLowerCase();
            let logo = null;
            let symbol = null;
            if(coinName == "signal" || coinName == "subscription" || coinName == "loan" || coinName == "401k"){
              logo = `/uploads/usd.svg`;
              symbol = "USD";
            }else{
              const asset = walletlist.find(asset => asset.name.toLowerCase() === coinName);
              if (asset) {
                logo = asset.logo;
                symbol = asset.symbol;
              }
            }
            return {
                ...tx,
                logo,
                symbol
            };
          });
          setTransferhistorys(updatedTrans);
      }
    })
      .catch(err => {
    })
  }, [user]);

  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Transfer" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Transfer" icon={<FontAwesomeIcon icon={faArrowUpFromBracket} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="container mt-md-5 mt-3 mb-5">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 mb-lg-5 mb-3">
                        <div className="mycard p-3 px-lg-4">
                            <h5 className="mb-0" style={{fontWeight:'900'}}>Transfer</h5>
                            <p className="mb-5">Internal transfers are free on Eaglescreener.</p>
                            <div className="mycard p-3 px-lg-4">
                                <div className="d-flex align-items-center noSelect">
                                  <FontAwesomeIcon icon={faCoins} style={{fontSize: '16px'}} />
                                  <p className="mb-0 fw-semibold text-uppercase ms-3" style={{minWidth:'70px'}}>From</p>
                                  <Select 
                                    options={routes} 
                                    value={routes.find((opt) => opt.value === from)}
                                    onChange={(selected) => {
                                        setFrom(selected.value);
                                        selected.value != 'assets' ? setBal(selected.bal) : setBal(0);
                                        validateSymbol(selected.value);
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles}
                                    className="flex-grow-1"
                                  />
                                </div>
                                <div className="d-flex align-items-center justify-content-between my-3">
                                  <FontAwesomeIcon icon={faArrowDownLong} className="text-secondary" style={{fontSize: '16px'}} />
                                  <FontAwesomeIcon icon={faShuffle} className="text-prime" style={{fontSize: '20px',cursor:'pointer'}} onClick={Shuffle} />
                                </div>
                                <div className="d-flex align-items-center noSelect">
                                  <FontAwesomeIcon icon={faCircleDollarToSlot} style={{fontSize: '16px'}} />
                                  <p className="mb-0 fw-semibold text-uppercase ms-3" style={{minWidth:'70px'}}>To</p>
                                  <Select 
                                    options={routes} 
                                    value={routes.find((opt) => opt.value === to)}
                                    onChange={(selected) => {
                                        setTo(selected.value);
                                        setAsset1('');
                                    }}
                                    isSearchable
                                    styles={darkThemeStyles}
                                    className="flex-grow-1"
                                  />
                                </div>
                            </div>
                            <hr className="my-4" style={{opacity:'0.07'}}/>
                            {from == 'assets' && (
                            <>
                              <label className="fw-semibold mb-1">From Coin</label>
                              <Select 
                                options={walletlist} 
                                value={walletlist.find((opt) => opt.value === asset)}
                                onChange={(selected) => {validateAssets(selected);}}
                                isSearchable
                                styles={darkThemeStyles}
                                className="w-full mb-3"
                              />
                            </>
                            )}
                            {to == 'assets' && (
                            <>
                              <label className="fw-semibold mb-1">To Coin</label>
                              <Select 
                                options={walletlist} 
                                value={walletlist.find((opt) => opt.value === asset)}
                                onChange={(selected) => {validateAssets1(selected);}}
                                isSearchable
                                styles={darkThemeStyles}
                                className="w-full mb-3"
                              />
                            </>
                            )}
                            <>
                              <div className="d-flex align-items-center justify-content-between">
                                <label className="fw-semibold mb-1">Amount:</label>
                                <label className="text-secondary mb-1" style={{fontSize:'14px'}}>Bal: {from == 'assets'? Number(bal/price).toFixed(5) : formatCurrency(bal)} {symbol}</label>
                              </div>
                              <div className={`d-flex align-items-between form-control justify-content-between py-2 pe-1 ${error ? 'input-error' : ''}`}>
                                  <input 
                                      type="text" 
                                      placeholder="0.00" 
                                      className="inputNone"
                                      value={amount}
                                      onChange={(e) => validateAmount(e.target.value)}
                                  />
                                  <div className="fw-bold text-white d-flex align-items-center" style={{backgroundColor: 'rgb(30, 33, 36)', borderRadius:'4px',padding: '6px',fontSize: '14px', cursor: 'pointer'}}>
                                  {symbol}
                                  </div>
                              </div>
                            </>
                            {error && (
                                <p className="mb-0 text-danger fs-7 mt-1">Your current balance is below the current amount.</p>
                            )}
                            <div className="d-flex justify-content-end">
                                <div className={`myBtn mt-4 text-center px-4 py-3 rounded-2 d-block ${disable?'disabled':null}`} onClick={!disable?ValidateTransfer:null}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Confirm'}</div>
                            </div>
                        </div>
                    </div>
                      <div className="col-12">
                        <div className="mycard">
                            <div className="table-responsive">
                                <table className="table table-borderless table-dark align-middle">
                                    <thead>
                                        <tr className="fs-7">
                                        <th className="fw-normal text-light">ID</th>
                                        <th className="fw-normal text-light d-md-table-cell d-none">Date</th>
                                        <th className="fw-normal text-light d-lg-table-cell d-none">From</th>
                                        <th className="fw-normal text-light d-lg-table-cell d-none">To</th>
                                        <th className="fw-normal text-light">Amount</th>
                                        <th className="fw-normal text-light">Status</th>
                                        <th className="fw-normal text-light d-lg-none d-table-cell"></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{fontSize: '14px'}}>
                                    {transferhistorys.length > 0 ? (
                                        transferhistorys.map((history, index) => (
                                            <TransferHistory index={index} history={history}/>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="py-5" colSpan={7}>You have not made any transfer yet.</td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Transfer